import { forwardRef, memo, useMemo } from 'react';
import styled from '@emotion/styled';
import TextareaAutosize from '@mui/material/TextareaAutosize';

export const Textarea = memo(
  styled(TextareaAutosize)(({ theme }) => ({
    width: '100%',
    boxSizing: 'border-box',
    borderStyle: 'solid',
    borderWidth: '2px',
    borderRadius: '7px',
    padding: '8px',
    outline: 'none',
    resize: 'none',
    lineHeight: '22px',
    fontFamily: theme.fonts.regular,
    fontSize: '16px',
    appearance: 'none',
    borderColor: theme.palette.gray.light1,
    '&:focus': {
      borderColor: theme.palette.sentiment?.primary?.main ?? theme.palette.primary.main,
    },
  }))
);

type TextareaCharacterLimitProps = {
  maxLength: number;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextareaCharacterLimit = forwardRef<HTMLTextAreaElement, TextareaCharacterLimitProps>(({
  maxLength,
  ...props
}, ref) => {
const value = String(props.value ?? '');
  const hasTooManyCharacters = useMemo(() => {
    return value.length > maxLength;
  }, [maxLength, value]);

  const count = (maxLength - value.length).toString();

  return (
    <CharacterLimitRoot>
      <Textarea ref={ref} {...props} />
      <CharacterCount warning={hasTooManyCharacters}>{count}</CharacterCount>
    </CharacterLimitRoot>
  );
});

TextareaCharacterLimit.displayName = 'TextareaCharacterLimit';

const CharacterLimitRoot = styled.div({
  width: '100%',
});

const CharacterCount = styled.div<{ warning: boolean }>(({ theme, warning }) => ({
  display: 'inline-block',
  color: warning ? theme.palette.error.main : undefined,
}));
